export function getReturnPath(location, searchParams) {
  const fromQuery = searchParams?.get?.('returnTo');
  if (fromQuery) {
    return fromQuery;
  }
  return location?.state?.returnTo || null;
}

export function navigateAfterFormSave(navigate, location, defaultPath, searchParams) {
  const returnTo = getReturnPath(location, searchParams);
  if (returnTo) {
    navigate(returnTo, { replace: true });
    return;
  }
  navigate(defaultPath);
}

export function navigateWithReturn(navigate, path, returnTo) {
  if (!returnTo) {
    navigate(path);
    return;
  }
  const separator = path.includes('?') ? '&' : '?';
  navigate(`${path}${separator}returnTo=${encodeURIComponent(returnTo)}`, {
    state: { returnTo },
  });
}
